import { ButtonColour } from 'components/Button/constants';
import { CuratedPageType } from 'pages/curated-pages/types';
import { CURATE_PAGE_URL } from 'modules/utils/constants';
import CtaButton from 'components/Cta/Button';

import styles from './styles.module.scss';
import { InformationCard } from 'components/CMSModals/informationcard';
import { htmlSafe } from 'modules/utils/utils';

type CuratedPagesItemProp = {
  curatedPage?: CuratedPageType;
  curatedCMSPages?: any;
};

const CuratedPagesItem: React.FC<CuratedPagesItemProp> = ({
  curatedPage,
  curatedCMSPages,
}) => {
  return (
    <article className={styles.curatedPagesItem}>
      {curatedCMSPages?.imageUrl && (
        <div className={styles.image}>
          <div
            style={{
              backgroundImage: `url(${curatedCMSPages?.imageUrl}?format=jpg&auto=webp?quality=60)`,
            }}
          >
            <span></span>
          </div>
        </div>
      )}
      <div className={styles.content}>
        <div>
          <h3>
            {curatedCMSPages?.title || curatedCMSPages?.title?.substring(0, 30)}
          </h3>
          {(curatedCMSPages?.description || curatedCMSPages?.description) && (
            <p>{htmlSafe(curatedCMSPages?.description?.substring(0, 140))}</p>
          )}
        </div>
        <CtaButton
          ariaLabel={
            curatedCMSPages?.title || curatedCMSPages?.title?.substring(0, 30)
          }
          defaultColour={ButtonColour.BRAND_BERRY}
          page_link={`${CURATE_PAGE_URL}${curatedCMSPages?.link}`}
          small
        />
      </div>
    </article>
  );
};

export default CuratedPagesItem;
